export function checkPassword(password: string) {
    const regex = new RegExp('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{5,32}$');
    if (regex.test(password)) {
      return true;
    } else {
      return false;
    }
  }